import { InteractionRequiredAuthError } from '@azure/msal-common';
import axios from 'axios';
import COMMON_MESSAGES from 'consts/message';
import { msalInstance } from 'index';
// import { isAdvancedSearch } from 'utils';


const isHandlerEnabled = true;



const RequestHandler = async (request: any, isHandlerEnabled: boolean) => {
  const account = msalInstance.getAllAccounts()[0];
  const accessTokenRequest = {
    scopes: ['https://graph.microsoft.com/.default'],
    account
  };
  const token = await msalInstance.acquireTokenSilent({
    ...accessTokenRequest
  });

  if (isHandlerEnabled && token) {
    // request.headers['Content-Type'] = 'application/json; charset=utf-8';
    // request.headers.Accept = 'application/json, text/javascript, */*; q=0.01';
    request.headers['Access-Control-Allow-Origin'] = '*';
    request.headers.Authorization = `Bearer ${token.idToken}`;
  }

  return request;
};

const successHandler = (response: any, isHandlerEnabled: boolean) => {
  return response;
};

// const errorHandler = async (error: any) => {
//   if (
//     error.response &&
//     error.response.status &&
//     error.response.status === 401
//   ) {
//     const isValidEndpoint = !EXCLUDES_API_URLS.includes(error.config.url);
//     if (isValidEndpoint) {
//       const originalRequest = error.config;
//       // eslint-disable-next-line no-underscore-dangle
//       originalRequest._retry = true;
//       try {
//         const refreshToken =
//           localStorage.getItem(SESSION_KEYS.REFRESH_TOKEN) || "";
//         const token = localStorage.getItem(SESSION_KEYS.ACCESS_TOKEN) || "";
//         const paramsRefreshToken: RefreshTokenParams = {
//           refreshToken,
//           token,
//         };
//         const refreshResponse: any = await refreshTokenRequest(
//           paramsRefreshToken
//         );
//         let newToken = refreshResponse?.content?.token;
//         let newRefreshToken = refreshResponse?.content?.refreshToken;
//         if (newToken) {
//           localStorage.setItem(SESSION_KEYS.ACCESS_TOKEN, newToken);
//           localStorage.setItem(SESSION_KEYS.REFRESH_TOKEN, newRefreshToken);
//           originalRequest.headers.Authorization = `${TokenKey} ${newToken}`;
//           // eslint-disable-next-line @typescript-eslint/return-await
//           return axiosInstance(originalRequest);
//         }
//         logoutRefreshStorage();
//       } catch (error) {
//         logoutRefreshStorage();
//       }
//     }
//   }
//
//   if (
//     (error.response &&
//       error.response.status &&
//       error.response.status === 400) ||
//     error.response.status === 500
//   ) {
//     return Promise.resolve(error.response);
//   }
//
//   return Promise.reject(error.response);
// };

/* eslint consistent-return: off */
const errorHandler = (error: any, isHandlerEnabled?: any) => {
  if (error instanceof InteractionRequiredAuthError) {
    // fallback to interaction when silent call fails
    const account = msalInstance.getAllAccounts()[0];
    const acquireTokenRedirectRequest = {
      scopes: ['https://graph.microsoft.com/.default'],
      loginHint: account.username // For v1 endpoints, use upn from idToken claims
      // redirectUri: process.env.REACT_APP_REDIRECT_LOGIN_URL
    };
    localStorage.clear();
    alert(COMMON_MESSAGES.MESSAGE_PLEASE_LOGIN);
    window.location.reload();
  } else {
    if (error?.response?.status === 401) {
      localStorage.clear();
      alert(COMMON_MESSAGES.MESSAGE_PLEASE_LOGIN);
      window.location.reload();
    }
    return Promise.reject(
      error.response
        ? error.response.data
        : error?.message === 'ExpiredTime'
        ? {
            errorType: 'ExpiredTime',
            errorMessage: 'Expired Time'
          }
        : {
            errorType: 'UnhandledException',
            errorMessage: 'Unhandled Exception'
          }
    );
  }
};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json; charset=utf8',
    Accept: 'application/json-patch+json, text/javascript, */*; q=0.01',
    'Access-Control-Allow-Origin': '*'
  },
  timeout: Number(process.env.NEXT_PUBLIC_TIME_OUT) || 60000,
  validateStatus(status: number) {
    return status >= 200 && status < 300;
  }
});

axiosInstance.interceptors.response.use(
  (response: any) => {
    return successHandler(response.data, isHandlerEnabled);
  },
  (error: any) => {
    return errorHandler(error);
  }
);

axiosInstance.interceptors.request.use(
  (request) => {
    const base = process.env.REACT_APP_BASE_URL || "";
    // request.baseURL = process.env.REACT_APP_ENV === 'LOCAL' ? base.replace("v1", "v3") : base
    request.baseURL = base
    return RequestHandler(request, isHandlerEnabled);
  },
  (error: any) => errorHandler(error)
);

export default axiosInstance;
